import React from 'react';
import VideoInlineBlock from 'libs/wordpress/content/cmsBlocks/VideoInlineBlock';

const VideoInlineModule = ({ ...rest }) => (
    // Because every module should be wrapped in a section
    <section>
        <VideoInlineBlock {...rest} />
    </section>
);

export default VideoInlineModule;
